import { StyledPageError } from "./PageError403.styled";
import image403 from "../../../images/error_403.svg";
import { BodyTyp, TitlesTyp } from "../../../components/Typography/Typography";
import { FontWeightEnum } from "../../../types/AppTypes";
import { theme } from "../../../constants/StyledComponents";
import {
  ACCESS_DENIED_LABEL,
  COME_BACK_LABEL,
  ERROR_403_MESSAGE_P1_LABEL,
  ERROR_403_MESSAGE_P2_LABEL,
} from "../../../constants/Dictionary";
import { Button } from "../../../components/core/Button/Button";
import { Link } from "../../../components/core/Link/Link";

type PageError403Props = {
  logout: () => void;
};

const PageError403 = ({ logout }: PageError403Props) => {
  return (
    <StyledPageError>
      <div className="error-403-container">
        <div className="error-403-header">
          <img src={image403} width={350} />
        </div>
        <div className="error-403-content">
          <TitlesTyp
            variant="1"
            fontWeight={FontWeightEnum.SEMIBOLD}
            color={theme.colors.black}
          >
            {ACCESS_DENIED_LABEL}
          </TitlesTyp>
          <BodyTyp
            variant="1"
            fontWeight={FontWeightEnum.REGULAR}
            color={theme.colors.black}
          >
            {ERROR_403_MESSAGE_P1_LABEL}
          </BodyTyp>
          <div className="error-403-message">
            <BodyTyp
              variant="1"
              fontWeight={FontWeightEnum.REGULAR}
              color={theme.colors.black}
            >
              {ERROR_403_MESSAGE_P2_LABEL}
            </BodyTyp>
            <Link
              href="mailto:traininganddevelopment@abstract.it"
              underline
              color={theme.colors.purple}
            >
              traininganddevelopment@abstract.it
            </Link>
          </div>
          <Button label={COME_BACK_LABEL} onClick={logout} />
        </div>
      </div>
    </StyledPageError>
  );
};

export default PageError403;
